import { types } from '../types/types';

const initialState ={
    selectedPage: '/home'
}

export const sharingReducer = (state = initialState, action ) => {
    switch ( action.type ) {
        case types.selectedPage:
            return{
                ...state,
                selectedPage: action.payload,
            }
     
        default:
            return state;
    }
}